import { createContext } from "react";
import { CreditsContextProps, CreditsState,  } from "@/interfaces/credits.interface";

/**
 * Initial state for the CreditsContext.
 * Provides default values for token credits and model group information.
 */
export const CREDITS_INITIAL_STATE: CreditsState = {
  model_groups: []
};

/**
 * CreditsContext provides global token credits and model group state management.
 * Contains model groups with usage information and dispatch function for updates.
 * 
 * @context
 * @example
 * ```tsx
 * const { state, dispatch } = useContext(CreditsContext);
 * 
 * dispatch({ field: 'model_groups', value: updatedGroups });
 * ```
 */
export const CreditsContext = createContext<CreditsContextProps>(undefined!);
